import Component from 'gia/Component';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { gsap } from "gsap";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin)


export default class OffresPath extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      motifs: []
    };
  }

  mount() {
    let that = this;


    gsap.fromTo(this.ref.motifs, {

      // clipPath: 'inset(0% 100% 0% 0%)',
      scale: 0.7,
      opacity: 0
    }, {
      duration: 2, stagger: 0.2,
      // clipPath: 'inset(0% 0% 0% 0%)',
      scale: 1,
      opacity: 1,
      y: 0
    });


  }


}